// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ANEruKMmpbn8u2ZGns5t .pk8g2BYa92HNIOq9MUhz {
  padding: 8px;
  border-bottom: 1px solid #d2d2d2;
}
.ANEruKMmpbn8u2ZGns5t .WdLzLd3lJgPmy5QUMnj7 {
  display: flex;
}
.ANEruKMmpbn8u2ZGns5t .WdLzLd3lJgPmy5QUMnj7 .LVJuGjHg5pLqhqruf1W_ {
  flex: auto;
  padding: 0 16px;
}
.ANEruKMmpbn8u2ZGns5t .WdLzLd3lJgPmy5QUMnj7 .LVJuGjHg5pLqhqruf1W_ .HpcHHOio48fsDHPza9J2 {
  font-weight: 600;
  color: #000000;
  font-size: 18px;
}
.ANEruKMmpbn8u2ZGns5t .WdLzLd3lJgPmy5QUMnj7 .LVJuGjHg5pLqhqruf1W_ .HpcHHOio48fsDHPza9J2 .ant-input {
  width: 300px;
}
.ANEruKMmpbn8u2ZGns5t .WdLzLd3lJgPmy5QUMnj7 .LVJuGjHg5pLqhqruf1W_ .mKe_Wpl9TdxtWy6DXByH {
  color: #7d8592;
  font-size: 24px;
  padding: 0 10px;
}
.ANEruKMmpbn8u2ZGns5t .WdLzLd3lJgPmy5QUMnj7 .LVJuGjHg5pLqhqruf1W_ .yXIoXiNF3m7_QXTbzJ3Q {
  color: #666;
  font-size: 14px;
}
.ANEruKMmpbn8u2ZGns5t .WdLzLd3lJgPmy5QUMnj7 .LVJuGjHg5pLqhqruf1W_ > div {
  padding: 10px 0;
}
.ANEruKMmpbn8u2ZGns5t .WdLzLd3lJgPmy5QUMnj7 .LVJuGjHg5pLqhqruf1W_ .jWPANczBBCDZuBbD3Z5V {
  border-bottom: 1px solid #d2d2d2;
}
.ANEruKMmpbn8u2ZGns5t .WdLzLd3lJgPmy5QUMnj7 .LVJuGjHg5pLqhqruf1W_ .e1z8UxNv8gKNyQKksieQ {
  border-top: 1px solid #d2d2d2;
  border-bottom: 1px solid #d2d2d2;
}
.ANEruKMmpbn8u2ZGns5t .WdLzLd3lJgPmy5QUMnj7 .LVJuGjHg5pLqhqruf1W_ h5 {
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  line-height: 16px;
}
.ANEruKMmpbn8u2ZGns5t .WdLzLd3lJgPmy5QUMnj7 .fDR4A_FX5BzWW7RNXl0Q {
  border-left: 1px solid #d2d2d2;
  flex: 0 0 260px;
  padding: 16px;
}
.ANEruKMmpbn8u2ZGns5t .WdLzLd3lJgPmy5QUMnj7 .Uo_cIo1j8yLKQF2TI44Q {
  border-top: 1px solid #d2d2d2;
  padding-top: 8px;
}
.ANEruKMmpbn8u2ZGns5t .WdLzLd3lJgPmy5QUMnj7 .Uo_cIo1j8yLKQF2TI44Q ._nZvKTd7v_LtZUdBbBJY {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  margin-bottom: 8px;
}
.ANEruKMmpbn8u2ZGns5t .WdLzLd3lJgPmy5QUMnj7 .Uo_cIo1j8yLKQF2TI44Q ._nZvKTd7v_LtZUdBbBJY:last-child {
  margin-bottom: 0;
}
.ANEruKMmpbn8u2ZGns5t .WdLzLd3lJgPmy5QUMnj7 .Uo_cIo1j8yLKQF2TI44Q .cyA3aSl9E0WtnieW_KUg {
  flex: 0 0 60px;
}
.ANEruKMmpbn8u2ZGns5t .WdLzLd3lJgPmy5QUMnj7 .Uo_cIo1j8yLKQF2TI44Q .cyA3aSl9E0WtnieW_KUg span {
  font-weight: 500;
  color: #7d8592;
  line-height: 16px;
  background: #f5f6f8;
  border-radius: 4px;
  padding: 4px 8px;
}
.ANEruKMmpbn8u2ZGns5t .WdLzLd3lJgPmy5QUMnj7 .Uo_cIo1j8yLKQF2TI44Q .EoPMxbyyVZse_nLBWF0G {
  flex: auto;
}
.ANEruKMmpbn8u2ZGns5t .WdLzLd3lJgPmy5QUMnj7 .Uo_cIo1j8yLKQF2TI44Q .AtLTJ7XaMqfcRtYVWFte {
  flex: 0 0 200px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Project/Task/Detail/index.module.less"],"names":[],"mappings":"AACA;EAEI,YAAA;EACA,gCAAA;AADJ;AAFA;EAMI,aAAA;AADJ;AALA;EASM,UAAA;EACA,eAAA;AADN;AATA;EAYQ,gBAAA;EACA,cAAA;EACA,eAAA;AAAR;AAdA;EAiBY,YAAA;AAAZ;AAjBA;EAsBQ,cAAA;EACA,eAAA;EACA,eAAA;AAFR;AAtBA;EA4BQ,WAAA;EACA,eAAA;AAHR;AAMM;EACE,eAAA;AAJR;AA7BA;EAqCQ,gCAAA;AALR;AAhCA;EAyCQ,6BAAA;EACA,gCAAA;AANR;AApCA;EA8CQ,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAPR;AA1CA;EAsDM,8BAAA;EACA,eAAA;EACA,aAAA;AATN;AA/CA;EA4DM,6BAAA;EACA,gBAAA;AAVN;AAnDA;EA+DQ,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AATR;AAUQ;EACE,gBAAA;AARV;AA7DA;EA0EQ,cAAA;AAVR;AAhEA;EA4EU,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AATV;AAxEA;EAsFQ,UAAA;AAXR;AA3EA;EA0FQ,eAAA;AAZR","sourcesContent":["\n.container {\n  .breadcrumb {\n    padding: 8px;\n    border-bottom: 1px solid #d2d2d2;\n  }\n  .content {\n    display: flex;\n\n    .detail {\n      flex: auto;\n      padding: 0 16px;\n      .name {\n        font-weight: 600;\n        color: #000000;\n        font-size: 18px;\n        :global {\n          .ant-input {\n            width: 300px;\n          }\n        }\n      }\n      .num {\n        color: #7d8592;\n        font-size: 24px;\n        padding: 0 10px;\n      }\n\n      .parentTask {\n        color: #666;\n        font-size: 14px;\n      }\n\n      & > div {\n        padding: 10px 0;\n      }\n\n      .title {\n        border-bottom: 1px solid #d2d2d2;\n      }\n\n      .comments {\n        border-top: 1px solid #d2d2d2;\n        border-bottom: 1px solid #d2d2d2;\n      }\n\n      h5 {\n        font-size: 14px;\n        font-weight: bold;\n        color: #000000;\n        line-height: 16px;\n      }\n    }\n\n    .form {\n      border-left: 1px solid #d2d2d2;\n      flex: 0 0 260px;\n      padding: 16px;\n    }\n\n    .taskList {\n      border-top: 1px solid #d2d2d2;\n      padding-top: 8px;\n      .listItem {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        height: 32px;\n        margin-bottom: 8px;\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n\n      .itemNum {\n        flex: 0 0 60px;\n        span {\n          font-weight: 500;\n          color: #7d8592;\n          line-height: 16px;\n          background: #f5f6f8;\n          border-radius: 4px;\n          padding: 4px 8px;\n        }\n      }\n\n      .itemName {\n        flex: auto;\n      }\n\n      .itemAssign {\n        flex: 0 0 200px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ANEruKMmpbn8u2ZGns5t`,
	"breadcrumb": `pk8g2BYa92HNIOq9MUhz`,
	"content": `WdLzLd3lJgPmy5QUMnj7`,
	"detail": `LVJuGjHg5pLqhqruf1W_`,
	"name": `HpcHHOio48fsDHPza9J2`,
	"num": `mKe_Wpl9TdxtWy6DXByH`,
	"parentTask": `yXIoXiNF3m7_QXTbzJ3Q`,
	"title": `jWPANczBBCDZuBbD3Z5V`,
	"comments": `e1z8UxNv8gKNyQKksieQ`,
	"form": `fDR4A_FX5BzWW7RNXl0Q`,
	"taskList": `Uo_cIo1j8yLKQF2TI44Q`,
	"listItem": `_nZvKTd7v_LtZUdBbBJY`,
	"itemNum": `cyA3aSl9E0WtnieW_KUg`,
	"itemName": `EoPMxbyyVZse_nLBWF0G`,
	"itemAssign": `AtLTJ7XaMqfcRtYVWFte`
};
export default ___CSS_LOADER_EXPORT___;
